/**
 * The boot screen `index.html` paints before any JavaScript has run: the destination's own
 * ground (the marketplace's paper or night hero, the dashboard's light or dark background) with
 * the APMP mark turning in the middle.
 *
 * It sits **beside** `#app`, not inside it, because `app.mount()` empties `#app` — and mounting is
 * nowhere near the end of the wait. The first navigation still has the session bootstrap, the
 * page chunk and the layout chunk ahead of it, and a loader Vue had wiped at mount would leave
 * exactly the empty screen it exists to replace. So it stays up until the first layout is in the
 * DOM, and `App.vue` takes it down then.
 */
export const BOOT_SCREEN_ID = 'apmp-boot'

/**
 * Which ground the boot screen wears, set on `<html>` by `index.html` from the path before
 * anything paints: `home` (the hero's night), `marketplace` (paper under the night bar) or `app`
 * (the dashboard background, light or dark).
 */
export const BOOT_SURFACE_ATTRIBUTE = 'data-boot'

/** Remove the boot screen. Idempotent: every call after the first finds nothing to remove. */
export function dismissBootScreen(doc: Document = document) {
  doc.getElementById(BOOT_SCREEN_ID)?.remove()
  doc.documentElement.removeAttribute(BOOT_SURFACE_ATTRIBUTE)
}
